import AbstractConfig from './AbstractConfig';

export default class ResourceConfig extends AbstractConfig {
  public lights(): boolean {
    return !!this.get('lights');
  }

  public sidebar(): boolean {
    return !!this.get('sidebar');
  }
}
